module.exports = __webpack_public_path__ + "static/media/tick-check-mark-svgrepo-com.6a3dd82e.svg";